export function getPageNumber(pageParam: string | string[] | undefined) {
  if (typeof pageParam === 'string') {
    const page = pageParam.split('-')[1];
    return Number(page) - 1;
  } else {
    return 0;
  }
}
